<script>
import StickyBanner from '@/Components/Banners/StickyBanner'

export default {
    components: {
        StickyBanner
    },
    methods: {
        resetSuccessData() {
            this.$page.props.flash.success = null
        },
        resetWarningData() {
            this.$page.props.flash.warning = null
        },
        resetErrorData() {
            this.$page.props.flash.error = null
        }
    }
}
</script>

<template>
    <StickyBanner
        v-if="$page.props.flash.success"
        :auto-close="true"
        class="z-50"
        dusk="alert-success"
        @closed="resetSuccessData"
    >
        <span class="inline-flex items-center font-semibold">
            <i class="mr-2 fas fa-info-circle" />
            <span class="block whitespace-pre-wrap">{{ $page.props.flash.success }}</span>
        </span>
    </StickyBanner>
    <StickyBanner
        v-if="$page.props.flash.warning"
        banner-type="warning"
        :auto-close="true"
        class="z-50"
        dusk="alert-warning"
        @closed="resetWarningData"
    >
        <span class="inline-flex items-center font-semibold">
            <i class="mr-2 fas fa-info-circle" />
            <span class="block whitespace-pre-wrap">{{ $page.props.flash.warning }}</span>
        </span>
    </StickyBanner>
    <StickyBanner
        v-if="$page.props.flash.error"
        banner-type="error"
        :auto-close="false"
        class="z-50"
        dusk="alert-error"
        @closed="resetErrorData"
    >
        <span class="inline-flex items-center font-semibold">
            <i class="mr-2 fas fa-exclamation-triangle" />
            <span class="block whitespace-pre-wrap">{{ $page.props.flash.error }}</span>
        </span>
    </StickyBanner>
</template>
